import { render, staticRenderFns } from "./LiveStatusNotice.vue?vue&type=template&id=0197dc78&scoped=true&"
import script from "./LiveStatusNotice.vue?vue&type=script&lang=js&"
export * from "./LiveStatusNotice.vue?vue&type=script&lang=js&"
import style0 from "./LiveStatusNotice.vue?vue&type=style&index=0&id=0197dc78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0197dc78",
  null
  
)

export default component.exports